import { render, staticRenderFns } from "./ProfSalonResolver.vue?vue&type=template&id=0224a59b&scoped=true"
import script from "./ProfSalonResolver.vue?vue&type=script&lang=ts"
export * from "./ProfSalonResolver.vue?vue&type=script&lang=ts"
import style0 from "./ProfSalonResolver.vue?vue&type=style&index=0&id=0224a59b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0224a59b",
  null
  
)

export default component.exports